import { render } from "./Realisations.vue?vue&type=template&id=6d24a8d7&scoped=true"
import script from "./Realisations.vue?vue&type=script&lang=js"
export * from "./Realisations.vue?vue&type=script&lang=js"

import "./Realisations.vue?vue&type=style&index=0&id=6d24a8d7&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d24a8d7"]])

export default __exports__